const tool = {};

/**
 * @description 解析url地址拼接
 * @param {Object} obj 拼接的参数对象
 */
tool.urlPath = (obj) => {
    if (obj) {
        let pathStr = "";
        let ObjLe = Object.keys(obj).length;
        Object.keys(obj).forEach(function (key, index) {
            if (index == ObjLe - 1) {
                pathStr += key + "=" + obj[key]
            } else {
                pathStr += key + "=" + obj[key] + "&"
            }
        });
        return pathStr;
    } else {
        return "";
    }
};


/**
 * @description 文件后缀名生成 上传文件类型
 * @param {String} fileName 文件后缀名
 */
tool.fileType = (fileName) => {
    // 后缀获取
    let suffix = '';
    // 获取类型结果
    let result = '';
    try {
        const flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
    } catch (err) {
        suffix = '';
    }
    // fileName无后缀返回 false
    if (!suffix) {
        return false;
    }
    suffix = suffix.toLocaleLowerCase();
    // 图片格式
    const imglist = ['png', 'jpg', 'jpeg', 'gif'];
    // 进行图片匹配
    result = imglist.find(item => item === suffix);
    if (result) {
        if (suffix == 'png') {
            return 'image/png';
        } else if (suffix == 'jpg') {
            return 'image/jpeg';
        } else if (suffix == 'jpeg') {
            return 'image/jpeg';
        } else if (suffix == 'gif') {
            return 'image/gif';
        }

    }
    // 匹配txt
    const txtlist = ['txt'];
    result = txtlist.find(item => item === suffix);
    if (result) {
        return 'text/plain';
    }
    // 匹配 excel
    const excelist = ['xls', 'xlsx'];
    result = excelist.find(item => item === suffix);
    if (result) {
        if (suffix === 'xls') {
            return 'application/vnd.ms-excel';
        } else if (suffix == 'xlsx') {
            return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        }
    }
    // 匹配 word
    const wordlist = ['doc', 'docx'];
    result = wordlist.find(item => item === suffix);
    if (result) {
        if (suffix == 'doc') {
            return 'application/msword';
        } else if (suffix == 'docx') {
            return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        }
    }
    // 匹配 pdf
    const pdflist = ['pdf'];
    result = pdflist.find(item => item === suffix);
    if (result) {
        return 'application/pdf';
    }
    // 匹配 ppt
    const pptlist = ['ppt', 'pptx'];
    result = pptlist.find(item => item === suffix);
    if (result) {
        if (suffix == 'ppt') {
            return 'application/vnd.ms-powerpoint'
        } else {
            return 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        }
    }
    // 匹配 视频
    const videolist = ['mp4', 'avi'];
    result = videolist.find(item => item === suffix);
    if (result) {
        if (suffix == 'mp4') {
            return 'audio/mp4,video/mp4'
        } else if (suffix == 'avi') {
            return 'video/x-msvideo'
        }
    }
    // 匹配 音频
    const radiolist = ['mp3', 'wav'];
    result = radiolist.find(item => item === suffix);
    if (result) {
        if (suffix == 'mp3') {
            return 'audio/mpeg'
        } else if (suffix == 'wav') {
            return 'audio/x-wav'
        }
    }
};


/**
 * @description 身份证校验
 * @param {String} idcode 身份证号码
 */
tool.checkIDCard = (idcode) => {
    // 加权因子
    let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    // 校验码
    let check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];

    let code = idcode + "";
    let last = idcode[17]; //最后一位

    let seventeen = code.substring(0, 17);

    // ISO 7064:1983.MOD 11-2
    // 判断最后一位校验码是否正确
    let arr = seventeen.split("");
    let len = arr.length;
    let num = 0;
    for (let i = 0; i < len; i++) {
        num = num + arr[i] * weight_factor[i];
    }

    // 获取余数
    let resisue = num % 11;
    let last_no = check_code[resisue];

    // 格式的正则
    // 正则思路
    /*
              第一位不可能是0
              第二位到第六位可以是0-9
              第七位到第十位是年份，所以七八位为19或者20
              十一位和十二位是月份，这两位是01-12之间的数值
              十三位和十四位是日期，是从01-31之间的数值
              十五，十六，十七都是数字0-9
              十八位可能是数字0-9，也可能是X
              */
    let idcard_patter =
        /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;

    // 判断格式是否正确
    let format = idcard_patter.test(idcode);

    // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
    return last === last_no && format ? true : false;
}

/**
 * @description 获取病症分类树形数据
 * @param {Array} data 数据源
 * @param {String} pid pid
 */
tool.getDataItemTreeData = (data, parent) => {
    if (!data) {
        return [];
    }
    let tree = [];
    let temp;
    for (var i = 0; i < data.length; i++) {
        if (data[i].pid == parent) {
            let objData = data[i];
            objData.id = data[i].itemvalue1 + "*" + data[i].name;
            objData.label = data[i].name;
            var obj = objData;
            temp = tool.getDataItemTreeData(data, data[i].itemvalue1);
            if (temp.length > 0) {
                let objdatas = temp;
                objdatas.id = temp.itemvalue1;
                objdatas.label = temp.name;
                obj.children = objdatas;
            }
            tree.push(obj);
        }
    }
    return tree;
}

/**
 * @description 获取医疗技术树形数据
 * @param {Array} data 数据源
 * @param {String} pid pid
 */
tool.getDataItemTreeData1 = (data, parent) => {
    if (!data) {
        return [];
    }
    let tree = [];
    let temp;
    for (var i = 0; i < data.length; i++) {
        if (data[i].pid == parent) {
            let objData = [];
            objData.id = data[i].id + "*" + data[i].itemvalue1;
            objData.label = data[i].name;
            var obj = objData;
            temp = tool.getDataItemTreeData1(data, data[i].id);
            if (temp.length > 0) {
                let objdatas = temp;
                objdatas.id = temp.id + "*" + temp.itemvalue1;
                objdatas.label = temp.name;
                obj.children = objdatas;
            }
            tree.push(obj);
        }
    }
    return tree;
}


/**
 * @description 获取执业类别 树形数据
 * @param {Array} data 数据源
 * @param {String} pid pid
 */
tool.getZYLBTreeData = (data, parent) => {
    if (!data) {
        return [];
    }
    let tree = [];
    let temp;
    for (var i = 0; i < data.length; i++) {
        if (data[i].pid == parent) {
            let objData = [];
            objData.id = data[i].itemvalue1;
            objData.label = data[i].name;
            var obj = objData;
            temp = tool.getZYLBTreeData(data, data[i].id);
            if (temp.length > 0) {
                let objdatas = temp;
                objdatas.id = temp.itemvalue1;
                objdatas.label = temp.name;
                obj.children = objdatas;
            }
            tree.push(obj);
        }
    }
    return tree;
}

//格式化日期
tool.dateFormat = (fmt, date) => {
    var o = {
        "M+": date.getMonth() + 1,                 //月份
        "d+": date.getDate(),                    //日
        "h+": date.getHours(),                   //小时
        "m+": date.getMinutes(),                 //分
        "s+": date.getSeconds(),                 //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

export default tool;